export const drivers = `drivers`;
export const trucks = `trucks`;
export const facilities = `facilities`;
export const users = `users`;
export const serviceCalls = `serviceCalls`;
export const airQuality = `airQualitySensors`
